import main from "emun.cart/multi-cart/multi-cart.htm";
// import "emun.cart/multi-cart/multi-cart.checkout-payment.htm";
import shipping from "emun.cart/multi-cart/multi-cart.checkout-shipping.htm";
import checkout from "emun.cart/multi-cart/multi-cart.checkout.htm";
import confirmation from "emun.cart/multi-cart/multi-cart.confirmation.htm";
import dropdown from "emun.cart/multi-cart/multi-cart.dropdown.htm";
import summary from "emun.cart/multi-cart/multi-cart.summary.htm";

export default {
  main,
  shipping,
  checkout,
  dropdown,
  summary,
  confirmation,
};
